import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import BeatLoader from "../../common/Loader/BeatLoader";
import { useLocation } from "react-router-dom";
import i18next from 'i18next';
import { useTranslation } from "react-i18next";
import { useNetworkError } from "../../hooks/context/NetworkErrorContext";
import { getEnvVar } from "../../config/env-config";

function WLTermsConditions() {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [details, setDetails] = useState(null);
    const location = useLocation();
    var currentPath = location.pathname + location.search;
    const [languageValue, setLanguageValue] = useState('en');
    const { setInternetError } = useNetworkError(); // Using the context

    // Set language according current local
    useEffect(() => {
        setLanguageValue(navigator.language === 'en-US' ? 'en' : 'gn')
        i18next.changeLanguage(navigator.language === 'en-US' ? 'en' : 'fr'); // Change the i18next language
        localStorage.setItem("handleSelectedLanguage", navigator.language === 'en-US' ? 'english' : 'guinea');
    }, [navigator.language]);

    // Get details
    const getDetails = () => {
        axios
            .post(
                (getEnvVar('REACT_APP_API_ADMIN_PUBLIC_URL') || '') + "api/public/get_admin_term_condition",
                {},
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        // "api-token": "68481d08a799ad6967f57263",
                    },
                }
            )
            .then((response) => {
                if (response.data.code === 200) {
                    const enPolicy = response.data.data.TermsAndConditions[0].translations.find(
                        (t) => t.language === languageValue
                    );
                    if (enPolicy) {
                        setDetails(enPolicy);
                    } else {
                        toast.error("English privacy policy not found.");
                    }
                } else if (response.data.code === 500) {
                    toast.error(response.data.message);
                } else if (response.data.code === 503) {
                    window.location.href = `/maintenece_mode?redirect=${encodeURIComponent(currentPath)}`;
                } else if (response.data.code === 404) {
                    toast.error(response.data.message);
                } else {
                    toast.error(response.data.message, { autoClose: 5000 });
                }
            }).catch((error) => {
                console.error("API Error:", error);

                // if (!error.response) {
                //     // Network/connection/server error
                //     setInternetError(true);
                // } else {
                //     setInternetError(false);
                // }

                toast.error("Failed to load booking details.");
            }).finally(() => {
                setLoading(false);
            });
    };

    // Get details
    useEffect(() => {
        getDetails();
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white p-5 text-gray-900 flex justify-center">
            <div className="w-full bg-white rounded-xl shadow-lg p-10 prose prose-indigo prose-lg ">
                {/* <h1 className="text-3xl font-extrabold mb-6 text-center text-indigo-600">
                    Customer Terms & Conditions
                </h1> */}

                {loading ? (
                    <div className="flex justify-center items-center space-x-3">
                        {/* Loading spinner here */}
                        <BeatLoader loading={loading} />
                    </div>
                ) : details ? (
                    <div
                        className="text-left"  // <-- add this to force left align policy content
                        dangerouslySetInnerHTML={{ __html: details.description }}
                    />
                ) : (
                    <div className="text-center text-red-600 text-[30px]">
                        {t('main.GDPR.Terms_conditions_not_found')}
                    </div>
                )}
            </div>
        </div>
    );

}

export default WLTermsConditions;
